import moment from "moment";
import * as storageService from '../common/services/storage.service';
import {ENV_AUTH} from '../../envirement';

//const baseAuth = "Basic " + window.btoa('mobile_client:some_secret') //for prod
//const baseAuth = "Basic " + window.btoa('mobile_client_test:some_secret') //for test

const baseAuth = "Basic " + window.btoa(`${ENV_AUTH}:some_secret`)

//const refreshAuth = "Basic " + window.btoa('mobile_client_test:some_secret') // to be deleted

export const BASE_TOKEN_OPTIONS = {
    crossDomain: true,
    mode: 'no-cors',
    headers: {
      'Authorization'   : baseAuth,
      'Content-Type'    : 'application/x-www-form-urlencoded',
      'Accept'          : '*/*',
      'Accept-Language' : 'bg',
    }
  }

  export const REFRESH_TOKEN_OPTIONS = {
    crossDomain: true,
    mode: 'no-cors',
    headers: {
      'Authorization'   : baseAuth,
      'Content-Type'    : 'application/x-www-form-urlencoded',
      'Accept'          : '*/*',
      'Accept-Language' : 'bg',
    }
  }

  export const BASE_TOKEN_BODY = encodeURI('grant_type=client_credentials');

  export const setLoginTokenBody = (username, passsword) => {
    const uri = `grant_type=password&username=${username}&password=${passsword}&scope=E_MOBILE&system=E-MOBILE.BG`;
    
    return encodeURI(uri);    
  }

  export const setRefreshTokenBody = (refreshToken) => {
    const uri = `grant_type=refresh_token&refresh_token=${refreshToken}&client_id=${ENV_AUTH}`;

    return encodeURI(uri);
  }

const getBrowser = () => {
  var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 
  if(/trident/i.test(M[1])){
      tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
      return {name:'IE',version:(tem[1]||'')};
      }   
  if(M[1]==='Chrome'){
      tem=ua.match(/\bOPR|Edge\/(\d+)/)
      if(tem!=null)   {return {name:'Opera', version:tem[1]};}
      }   
  M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
  if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
  return {
    name: M[0],
    version: M[1]
  };
}

  const setDefaultOptions = (token) => {
    let browser = getBrowser();
    browser = browser.name + ' v.' + browser.version;
    //console.log(browser)

    return {
      headers: {
        'Authorization'       : `Bearer ${token}`,
        'Content-Type'        : 'application/json; charset=utf-8',
        'Accept'              : '*/*', //'application/json',
        'Accept-Language'     : 'en',
        'Nuins-Channel'       : 'MOBILE',
        'Nuins-Referer'       : '/',
        'Nuins-Client-Time'   : moment().format(),
        'Nuins-Theme'         : 'E_MOBILE',
        'Nuins-Device-Id'     : 'A1B2D1A9-DD3F-4318-BB82-074434B60C18',
        'Nuins-Client-Version': browser, //'13.4'
        'Nuins-Device-OS'     : 'web',//'iPhone, 13.4',
        'Nuins-App-Version'   : '1.0.1',

      }
    }
  }

  const setFileOptions = (token, boundary) => {
    let browser = getBrowser();
    browser = browser.name + ' v.' + browser.version;

    return {
      headers: {
        'Authorization'       : `Bearer ${token}`,
        'Content-Type'        : `multipart_form_data; boundary=${boundary}`,
        'Accept'              : '*/*',
        'Accept-Language'     : 'en',
        'Nuins-Channel'       : 'MOBILE',
        'Nuins-Referer'       : '/',
        'Nuins-Client-Time'   : moment().format(),
        'Nuins-Theme'         : 'E_MOBILE',
        'Nuins-Device-Id'     : 'A1B2D1A9-DD3F-4318-BB82-074434B60C18',
        'Nuins-Client-Version': browser, //'13.4'
        'Nuins-Device-OS'     : 'web',//'iPhone, 13.4',
        'Nuins-App-Version'   : '1.0.1',

      }
    }
  }

  // const setAcceptAllOptions = (token) => {
  //   return {
  //     headers: {
  //       'Authorization'       : `Bearer ${token}`,
  //       'Content-Type'        : 'application/json; charset=utf-8',
  //       'Accept'              : '*/*',
  //       'Accept-Language'     : 'en',
  //       'Nuins-Channel'       : 'MOBILE',
  //       'Nuins-Referer'       : '/',
  //       'Nuins-Client-Time'   : moment().format(),
  //       'Nuins-Theme'         : 'E_MOBILE',
  //       'Nuins-Device-Id'     : 'A1B2D1A9-DD3F-4318-BB82-074434B60C18',
  //       'Nuins-Client-Version': '13.4',
  //       'Nuins-Device-OS'     : 'web',//'iPhone, 13.4',
  //       'Nuins-App-Version'   : '1.0.1',

  //     }
  //   }
  // }

  export const generateDefaultOptions = (auth) => {
    if (!auth) return;

    const token = storageService.isValidLoginToken(auth.loginToken) ? auth.loginToken?.access_token : auth.baseToken?.access_token

    return setDefaultOptions(token);
  }

  export const generateFileOptions = (auth, boundary) => {
    if (!auth) return;

    const token = storageService.isValidLoginToken(auth.loginToken) ? auth.loginToken?.access_token : auth.baseToken?.access_token

    return setFileOptions(token, boundary);
  }

  // export const generateAcceptAllOptions = (auth) => {
  //   if (!auth) return;

  //   const token = storageService.isValidLoginToken(auth.loginToken) ? auth.loginToken?.access_token : auth.baseToken?.access_token

  //   return setAcceptAllOptions(token);
  // }

  export const regPropsTemp = {
    "registrationProps": {
        "category": null,
        "color": "червен",
        "colorId": null,
        "engineCapacity": "2000",
        "engineType": "1",
        "firstRegDate": "1993-04-23",
        "fuelType": "1",
        "make": "NISSAN",
        "makeOther": null,
        "maxPower": "116",
        "model": "PRIMERA",
        "modelOther": null,
        "ownerCertNo": "000124824",
        "plate": "C3475HP",
        "registrationType": "1",
        "seatsCount": "5",
        "typeIntTalonId": null,
        "vin": "SJNFCAP10U0241897",
        "weight": null,
        "weightF1": "2000",
        "weightF3": null,
        "weightG": "2000",
        "yearOfManufacturing": null
    },
    "questions": {
        "commenceDate": "2021-01-14",
        "driverYearsOfPractice": "9",
        "driversAge": "45",
        "generalRegistrationType": "0",
        "isDriverForeigner": "0",
        "isInsurerForeigner": "0",
        "isRightWheelDrive": "0",
        "locationId": "68134",
        "moreThan60DaysAbroad": "0",
        "ownerType": "0",
        "vehicleType": "1",
        "vehicleUsage": "1"
    },
    "insurancePerson": {
        "addressId": "null",
        "birthDate": "1975-04-27",
        "family": "Moldovanski",
        "familyCyr": "Молдовански",
        "gender": "M",
        "name": "Svetoslav",
        "nameCyr": "Светослав",
        "nationality": "BG",
        "personPublicId": "7504276847",
        "personType": "INDIVIDUAL",
        "postCode": "1000",
        "role": "INSURED",
        "surname": "Stoyanov",
        "surnameCyr": "Стоянов"
    }
}

//asset_id=101181154968178&business_id=818487635345358